import { call, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import {
  LIST_IMPORTED_EXAMS,
  setImportedExams,
  GET_LAST_IMPORTED_AT,
  setLastImportedAt,
  SEARCH_NEW_EXAMS,
  GET_CANDIDATE_COLLECTIONS,
  IMPORT_ERROR_TO_COLLECTION
} from '@actions/exam'
import apiConfig from '@services/apiConfig'
import errorHandler from '../errorHandler'

const classPrefix = '/lab-exams'

function* listImportedExams({ options, callback }) {
  try {
    const { page = 0, limit = 100, append = false } = options || {}
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}`,
      params: { page, limit },
    })
    const {
      content = [], number = page, last = true, totalElements = 0,
    } = response.data || {}
    yield put(setImportedExams({
      content,
      page: number,
      last,
      total: totalElements,
      append,
    }))
    callback && callback(totalElements)
  } catch (error) {
    errorHandler(error)
    callback && callback()
  }
}

function* getLastImportedAt() {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/last-imported-date`,
    })
    yield put(setLastImportedAt(response.data))
  } catch (error) {
    errorHandler(error)
  }
}

function* searchNewExams({ startDate, endDate, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/search-new-exams`,
      params: { startDate, endDate },
    })
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
    callback && callback()
  }
}

function* getCandidateCollections({ cpf, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix + classPrefix}/candidate-collections`,
      data: { cpf },
    })
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
    callback && callback()
  }
}

function* importErrorToCollection({ errorId, collectionId, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix + classPrefix}/errors/${errorId}/import-to-collection/${collectionId}`,
    })
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
    callback && callback()
  }
}

export function* listImportedExamsSaga() {
  yield takeLatest(LIST_IMPORTED_EXAMS, listImportedExams)
}

export function* getLastImportedAtSaga() {
  yield takeLatest(GET_LAST_IMPORTED_AT, getLastImportedAt)
}

export function* searchNewExamsSaga() {
  yield takeLatest(SEARCH_NEW_EXAMS, searchNewExams)
}

export function* getCandidateCollectionsSaga() {
  yield takeLatest(GET_CANDIDATE_COLLECTIONS, getCandidateCollections)
}

export function* importErrorToCollectionSaga() {
  yield takeLatest(IMPORT_ERROR_TO_COLLECTION, importErrorToCollection)
}
